<template>
    <picture>
        <source v-if="imageConversionEnabled"
                :srcset="imgUrl + '.avif'"
                type="image/avif">
        <source v-if="imageConversionEnabled"
                :srcset="imgUrl + '.webp'"
                type="image/webp">
        <img :src="imgUrl"
             :alt="alt"
             :title="title"
             :class="imgClass"
             v-bind="additionalProps"
             @load="e => $emit('load',e)"
        >
    </picture>
</template>

<script>

    import { isBreakpointDown } from '../../helpers/device-size-check';
    import { detectAvif, detectWebP } from '../../../app/helper/featureDetect';
    import lozad from '../../../app/plugins/lozad';

    export default {
        name: 'ItemImage',
        inject: {
            itemId: {
                default: null,
            },
        },
        props: {
            imgClass: {
                type: String | Object,
                default: '',
            },
            imgUrl: {
                type: String,
                required: true,
            },
            alt: {
                type: String,
                default: '',
            },
            title: {
                type: String,
                default: '',
            },
            enableToolTip: {
                type: Boolean,
                default: false,
            },
            lazy: {
                type: Boolean,
                default: false,
            },
        },

        data() {
            return {
                imageConversionEnabled: App.config.log.modernImagesConversion,
            };
        },

        computed: {
            additionalProps() {
                const props = {};
                if (this.enableToolTip) {
                    props['data-toggle'] = 'tooltip';
                    props['data-placement'] = 'top';

                }
                if (this.lazy) {
                    props['loading'] = 'lazy';
                }
                return props;
            },
        },

    };
</script>
